// AppTheme.js
import { createTheme } from "@mui/material/styles";

export const AppTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: { main: mode === "dark" ? "#10a37f" : "#1976d2" },
      secondary: { main: mode === "dark" ? "#3c3f4a" : "#eeeeee" },
      background: {
        default: mode === "dark" ? "#1e1f22" : "#f4f5f7",
        paper: mode === "dark" ? "#2c2f33" : "#ffffff",
      },
      text: {
        primary: mode === "dark" ? "#ffffff" : "#111827",
        secondary: mode === "dark" ? "#a9aeb8" : "#6b7280",
      },
      divider: mode === "dark" ? "#3f444b" : "#e5e7eb",
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            // backgroundColor: "#2c2f33",
            // color: "#ffffff",
            boxShadow: "0 0 12px rgba(0,0,0,0.2)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 8,
            padding: "10px 20px",
            fontWeight: 500,
          },
          containedPrimary: {
            backgroundColor: "#10a37f",
            color: "#fff",
            "&:hover": {
              backgroundColor: "#0e8c6d",
            },
          },
          outlinedPrimary: {
            borderColor: "#10a37f",
            color: "#10a37f",
            "&:hover": {
              backgroundColor: "rgba(16, 163, 127, 0.1)",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-root": {
              backgroundColor: "#1f2226",
              color: "#fff",
            },
            "& .MuiInputLabel-root": {
              color: "#a9aeb8",
            },
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: "#3f444b",
            },
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            "&.Mui-selected": {
              backgroundColor: "#33373d",
              color: "#10a37f",
            },
            "&:hover": {
              backgroundColor: "#2c313a",
            },
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            backgroundColor: "#2c2f33",
            borderRadius: 8,
          },
          indicator: {
            backgroundColor: "#10a37f",
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            color: "#a9aeb8",
            "&.Mui-selected": {
              color: "#10a37f",
            },
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            backgroundColor: "#3f444b",
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: { backgroundColor: mode === "dark" ? "#333" : "#555" },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: { backgroundColor: mode === "dark" ? "#2c2f33" : "#fff" },
        },
      },
      MuiSnackbarContent: {
        styleOverrides: {
          root: {
            backgroundColor: mode === "dark" ? "#333" : "#444",
            color: "#fff",
          },
        },
      },
    },
  });
